












































































































import api from "@/api/index"; //ABP API接口
import {Vue, Component} from "vue-property-decorator";
import {
  VolunteerDto,
  VolunteerPagedResultRequestDto,
  VolunteerStatus,
} from "@/api/appService";
import PagedTableView from "@/components/PagedTableView/index.vue";
import EditServiceHistory from "@/views/volunteer/components/edit-serviceHistory.vue";
import ImportExcel from "@/components/ImportExcel/index.vue";
import ExportButton from "@/components/ExportButton/index.vue";

@Component({
  name: "ActivityList",
  components: {
    EditServiceHistory,
    PagedTableView,
    ImportExcel,
    ExportButton,
  },
})
export default class VolunteerList extends Vue {
  queryForm: VolunteerPagedResultRequestDto = {
    volunteerName: "",
    volunteerPhone: "",
    volunteerCode: "",
    status: undefined,
    includeUserExtend: true,
  };

  id: number = 0;

  statusList: any[] = [];

  created() {
    api.enumService
      .getValues({typeName: "VolunteerStatus"})
      .then((res: any) => {
        this.statusList = res;
      });
  }

  get VolunteerStatus() {
    return VolunteerStatus;
  }

  // 获取表数据
  fetchData(params: any) {
    console.log("test:" + params);
    return api.volunteer.getAll(params);
  }

  handleDetail(index: number, row: VolunteerDto) {
    this.$router.push({
      name: "VolunteerDetail",
      params: {id: `${row.id!}`},
      query: {},
    });
  }

  handelOnSaved() {
    this.fetchData(this.queryForm);
  }

  // 新建
  handleCreate() {
    this.$router.push({
      name: "volunteerCreate",
    });
  }

  handleEdit(index: number, row: VolunteerDto) {
    this.$router.push({
      name: "volunteerEdit",
      params: {id: row.id + ""},
    });
  }

  handleServiceHistory(index: number, row: VolunteerDto) {
    api.volunteerServiceHistory
      .getForEdit({
        id: 0,
      })
      .then(() => {
        let form = this.$refs.serviceHistoryForm as any;
        form.volunteerId = row.id;
        form.show = true;
      });
  }

  handleBan(index: number, row: VolunteerDto) {
    this.$confirm("你确定拉黑吗?", "提示").then(async () => {
      api.volunteer
        .ban({
          body: {
            id: row.id,
          },
        })
        .then(() => {
          this.fetchData(this.queryForm);
        });
    });
  }

  handleCancelBan(index: number, row: VolunteerDto) {
    api.volunteer
      .cancelBan({
        body: {
          id: row.id,
        },
      })
      .then(() => {
        this.fetchData(this.queryForm);
      });
  }

  handleAudit(index: number, row: VolunteerDto) {
    api.volunteer.postToAudit({body: {id: row.id}}).then(() => {
      this.fetchData(this.queryForm);
    });
  }

  handleReAudit(index: number, row: VolunteerDto) {
    api.volunteer.postTorReAudit({body: {id: row.id}}).then(() => {
      this.fetchData(this.queryForm);
    });
  }
}
